<ion-item>
	<ion-label>{{ to.data.title }}</ion-label>
	<ion-toggle [(ngModel)]="model[fieldKey]" (ionChange)="onModelChanged()"></ion-toggle>
</ion-item>